module.exports = __webpack_public_path__ + "static/img/todayArrears.37de9f9c.png";